import apiClient from './axiosClient';
import { getCurrentBranch } from './usersAPI';

export const getPricing = async () => {
  const response = await getCurrentBranch();
  const branchId = response.data.current_branch;
  return apiClient.get(`/branches/${branchId}/pricing/`);
};

export const getBranchPricingSettings = (branchId) =>
  apiClient.get(`/branches/${branchId}/settings-pricing/`);

export const patchBranchPricingSettings = (branchId, data) =>
  apiClient.patch(`/branches/${branchId}/settings-pricing/`, data);

export const getBusinessPricing = () => apiClient.get('/business/pricing/');

export const patchBusinessPricing = (data) =>
  apiClient.patch('/business/pricing/', data);